import { Loading } from '@wfp/ui';

export const LoginCallback = () => <Loading />;
